import React from 'react';
import styles from './styles/LearnerModal.module.css';
const currentYear = new Date().getFullYear();
const MAX_YEAR = currentYear - 18;
export default function LearnerModal({
  years,
  learnerName,
  setLearnerName,
  avatarUrl,
  setAvatarUrl,
  birthYear,
  setBirthYear,
  birthMonth,
  setBirthMonth,
  birthDay,
  setBirthDay,
  learnerDescription,
  setLearnerDescription,
  currentLearner,
  onClose,
  onSave,
  onDelete,
}) {
  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <button className={styles.closeModalBtn} onClick={onClose}>
          &times;
        </button>

        <h2>Settings for Learner</h2>

        <h3>Learner name</h3>
        <input
          id="learnerName"
          type="text"
          value={learnerName}
          onChange={(e) => setLearnerName(e.target.value)}
          className={styles.inputField}
        />

        <h3>Avatar</h3>
        <p className={styles.subtext}>
          Pick your learner’s avatar. We’ll highlight the one you select!
        </p>
        <div className={styles.avatarChoices}>
          {[
            '',
            '/images/sun_avatar.png',
            '/images/cat_avatar.png',
            '/images/fox_avatar.png',
            '/images/sunflower_avatar.png',
            '/images/bunny_avatar.png',
            '/images/unicorn_avatar.png',
            '/images/sunglasses_avatar.png',
          ].map((url) => (
            <div
              key={url || 'default'}
              className={`${styles.avatarOption} ${
                avatarUrl === url ? styles.selected : ''
              }`}
              onClick={() => setAvatarUrl(url)}
            >
              {url ? (
                <img src={url} alt="avatar" className={styles.avatarIcon} />
              ) : (
                <span style={{ fontSize: '2rem' }}>☀️</span>
              )}
            </div>
          ))}
        </div>

        {!currentLearner && (
          <>
            <h3>Date of Birth</h3>
            <div className={styles.dobContainer}>
              <select
                value={birthYear}
                onChange={(e) => setBirthYear(e.target.value)}
              >
                <option value="">Year</option>
                {Array.from(
                  { length: currentYear - MAX_YEAR + 1 },
                  (_, i) => currentYear - i
                ).map((y) => (
                  <option key={y} value={y}>
                    {y}
                  </option>
                ))}
              </select>
              <select
                value={birthMonth}
                onChange={(e) => setBirthMonth(e.target.value)}
              >
                <option value="">Month</option>
                {Array.from({ length: 12 }, (_, i) => i + 1).map((m) => (
                  <option key={m} value={m}>
                    {m}
                  </option>
                ))}
              </select>
              <select
                value={birthDay}
                onChange={(e) => setBirthDay(e.target.value)}
              >
                <option value="">Day</option>
                {Array.from({ length: 31 }, (_, i) => i + 1).map((d) => (
                  <option key={d} value={d}>
                    {d}
                  </option>
                ))}
              </select>
            </div>
          </>
        )}

        <h3>Learner description</h3>
        <textarea
          id="learnerDescription"
          value={learnerDescription}
          onChange={(e) => setLearnerDescription(e.target.value)}
          className={styles.inputField}
        />

        {currentLearner && (
          <button
            type="button"
            className={styles.deleteLearnerBtn}
            onClick={onDelete}
          >
            Delete Learner
          </button>
        )}

        <div className={styles.modalActions}>
          <button className={styles.cancelBtn} onClick={onClose}>
            Cancel
          </button>
          <button className={styles.saveBtn} onClick={onSave}>
            Save
          </button>
        </div>
      </div>
    </div>
  );
}